export default __webpack_public_path__ + "static/media/me.7d298d9c.jpeg";